import React, { useState } from 'react';
//import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { HashRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import { Grommet, Box, Text, Notification, Anchor, Image } from 'grommet';
import { hpe } from 'grommet-theme-hpe';
import { Hpe } from 'grommet-icons';

import MainComponent from './app/main-tab/MainComponent';
import SPPComponent from './app/spp-page/SPPComponent';
import PatchComponent from './app/patch-page/PatchComponent';


import LicenseAgreementComponent from './app/licenseagreement-page/LicenseAgreementComponent';

import { useTranslation } from 'react-i18next';
import i18n from './i18n'; 

// Define your custom theme
const theme = {
  global: {
    colors: {
      brand: '#0072c6', // HPE primary color
      background: {
        dark: '#111111',
        light: '#FFFFFF',
      },
    },
    font: {
      family: 'MetricBold, Arial, sans-serif',
    },
  },
  button: {
    border: {
      radius: '4px',
    },
  },
  card: {
    container: {
      background: '#F2F2F2',
      elevation: 'medium',
    },
  },
  icon: {
    colors: {
      favorite: 'red',
      share: 'plain',
    },
  },
};

// Component for rendering based on URL
const AppContent = () => {
  const location = useLocation();
  const { pathname } = location;
  //const pathname = location.pathname; // above line need to uncomment 
 // const pathname = window.location.hash.replace(/^#/, ''); // removes '#' from '#/ja/...'
 const rawHash = window.location.hash;
// const pathname = window.location.hash.replace(/^#/, '');
// const pathname = rawHash ? rawHash.replace(/^#/, '') : '/index.aspx'; 
 const pathSegments = pathname.split('/').filter(Boolean);
  //const pathSegments = pathname.split('/').filter(Boolean); // remove empty segments
  const langFromPath = pathSegments[0]; // e.g. 'ja' or 'en'
  const supportedLanguages = ['en', 'ja'];

  React.useEffect(() => {
    if (supportedLanguages.includes(langFromPath) && i18n.language !== langFromPath) {
      i18n.changeLanguage(langFromPath);
    }
  }, [langFromPath]);

  const pathnameWithoutLang = '/' + pathSegments.slice(1).join('/');


  const searchParams = new URLSearchParams(location.search);
  const version = searchParams.get('version');

  const getComponentToRender = () => {
    
    if (pathname.startsWith('/spp/patch/index.aspx') || pathname.startsWith('/spp/#/patch/index.aspx') || pathname.startsWith('/patch/index.aspx') || pathname.startsWith('/en/patch/index.aspx') || pathname.startsWith('/ja/patch/index.aspx')) {
      return <PatchComponent patchVersion={version} />;
    } else if (pathname.startsWith('/spp/index.aspx') || pathname.startsWith('/spp/#/index.aspx')) {
      return <SPPComponent version={version} />;
    } else if ((pathname === '/index.aspx') || (pathname === '/#/index.aspx') || (pathname === '/') || (pathname === '/en/index.aspx') || (pathname === '/ja/index.aspx')) {
      return <SPPComponent version="gen12.2025.05.00.00" />;
    }
    else if (pathname === '/spp/licenseagreements' || pathname === '/spp/#/licenseagreements') {
      return <LicenseAgreementComponent />;
    }
    else {
      <MainComponent></MainComponent>
    }
  };

  return (
    <Box direction="column">

      <MainComponent />


      {getComponentToRender()}

    </Box>
  );
};

function App() {
 const { t } = useTranslation();  

  const [isVisibleMessage1, setIsVisibleMessage1] = useState(true);
  const [isVisibleMessage2, setIsVisibleMessage2] = useState(true);
  const [isVisibleMessage3, setIsVisibleMessage3] = useState(true);
  const [isVisibleMessage4, setIsVisibleMessage4] = useState(true);
  const [isVisibleMessage5, setIsVisibleMessage5] = useState(true);
  const [isVisibleMessage6, setIsVisibleMessage6] = useState(true);

  const handleClose = (MessageFlag) => {
    if (MessageFlag === "1") {
      setIsVisibleMessage1(false);
    } else if (MessageFlag === "2") {
      setIsVisibleMessage2(false);
    } else if (MessageFlag === "3") {
      setIsVisibleMessage3(false);
    }
    else if (MessageFlag === "4") {
      setIsVisibleMessage4(false);
    }
    else if (MessageFlag === "5") {
      setIsVisibleMessage5(false);
    }
    else if (MessageFlag === "6") {
      setIsVisibleMessage6(false);
    }
  };
const app =() =>{

}
  return (
    <Grommet themeMode="light" theme={hpe}>
      {/* <Hpe size='large' color="plain" />
      <Text size="medium" style={{ fontFamily: 'MetricBold' }}>Hewlett Packard Enterprise</Text> */}
      {/* {isVisibleMessage4 && (
        <Box pad="1px">
          <Notification
            status="info"
            message={
              <Box width="950px" responsive={true}>
                <Text fontSize="medium" wordBreak="break-word">
                  Due to unanticipated circumstances, Gen11 2024.09.00.00 SPP will be delayed by a few days.
                </Text>
              </Box>
            }
            actions={[
              {
                href: "https://support.hpe.com/hpsc/doc/public/display?docId=emr_na-a00142315en_us",
                label: "Click on the CA link for more details",
                target: "_blank",
                rel: "noopener noreferrer",
              }
            ]}
            onClose={() => handleClose("4")}
          />
        </Box>
      )} */}

      {isVisibleMessage6 && (
        <Box pad="1px">
          <Notification
            status="info"
            message={
              <Box width="950px" responsive={true}>
                <Text fontSize="medium" wordBreak="break-word">
                  {t('alert6')}
                  <Anchor
                    href="https://support.hpe.com/hpsc/doc/public/display?docId=emr_na-a00163141en_us"
                    target="_blank"
                    rel="noopener noreferrer"
                    label="a00163141en_us."
                  />
                  {" "}{t('alert61')}
                </Text>
              </Box>
            }
            actions={[
              {
                href: "https://support.hpe.com/hpsc/doc/public/display?docId=emr_na-a00163141en_us",
                label: "Click on the CA link for more details",
                target: "_blank",
                rel: "noopener noreferrer",
              }
            ]}
            onClose={() => handleClose("6")}
          />
        </Box>
      )}

      {isVisibleMessage5 && (
        <Box pad="1px">
          <Notification
            status="info"
            message={
              <Box width="950px" responsive={true}>
                <Text fontSize="medium" wordBreak="break-word">
                  {" "}{t('alert5')}
                  <Anchor
                    href="https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00157444en_us"
                    target="_blank"
                    rel="noopener noreferrer"
                    label=" a00157444en_us"
                  />
                  {" "}{t('and')}{" "}
                  <Anchor
                    href="https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00156425en_us"
                    target="_blank"
                    rel="noopener noreferrer"
                    label="a00156425en_us"
                  />
                  {" "}{t('alert51')}
                </Text>
              </Box>
            }
            actions={[
              {
                href: "https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00157444en_us",
                label: "Click on CA a00157444en_us for more details",
                target: "_blank",
                rel: "noopener noreferrer",
              },
              {
                href: "https://support.hpe.com/hpesc/public/docDisplay?docLocale=en_US&docId=a00156425en_us",
                label: "Click on CA a00156425en_us for more details",
                target: "_blank",
                rel: "noopener noreferrer",
              }
            ]}
            onClose={() => handleClose("5")}
          />
        </Box>
      )}

      <Router>
        <Routes>
          <Route path="/*" element={<AppContent />} />
        </Routes>
      </Router>
    </Grommet>
  );
}

export default App;
